module.exports = __webpack_public_path__ + "static/media/001_A_infopanel.21067176.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/001_A_infopanel.png
// module id = 562
// module chunks = 0